import { render } from "./IntellifloOfficeDocumentsReportComponent.vue?vue&type=template&id=4ec438f4"
import script from "./IntellifloOfficeDocumentsReportComponent.vue?vue&type=script&lang=js"
export * from "./IntellifloOfficeDocumentsReportComponent.vue?vue&type=script&lang=js"

import "./IntellifloOfficeDocumentsReportComponent.vue?vue&type=style&index=0&id=4ec438f4&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__